import { C as e, F as t, L as n, h as r, i, ot as a, p as o, t as s, v as c, w as l } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { t as u } from "./LLMMessage.ce-DuEsMir7.js";
import { t as d } from "./shadow-dom-9FbsLIC0.js";
//#region src/webcomponents/pix-llm/LLMCompareMessages.ce.vue?vue&type=script&setup=true&lang.ts
var f = {
	class: "header",
	"aria-hidden": "true"
}, p = { class: "title-1" }, m = { class: "title-2" }, h = { class: "sr-only" }, g = { class: "llm-compare-messages" }, _ = { "aria-hidden": "true" }, v = /*#__PURE__*/ s(/* @__PURE__ */ l({
	__name: "LLMCompareMessages.ce",
	props: {
		conversation1: { type: Object },
		conversation2: { type: Object },
		userName: { type: String },
		messages: { type: Array }
	},
	setup(i) {
		return d(), (s, l) => (t(), c(o, null, [
			r("div", f, [r("div", null, [r("p", p, a(i.conversation1.title), 1)]), r("div", null, [r("p", m, a(i.conversation2.title), 1)])]),
			r("p", h, " Comparaison entre la conversation " + a(i.conversation1.title) + " et la conversation " + a(i.conversation2.title), 1),
			r("div", g, [(t(!0), c(o, null, n(i.messages, (n, a) => (t(), c("div", {
				key: a,
				class: "llm-compare-messages__row"
			}, [Array.isArray(n) ? (t(), c(o, { key: 0 }, [r("div", null, [e(u, {
				message: n[0],
				name: i.conversation1.llmName
			}, null, 8, ["message", "name"])]), r("div", null, [e(u, {
				message: n[1],
				name: i.conversation2.llmName
			}, null, 8, ["message", "name"])])], 64)) : (t(), c(o, { key: 1 }, [r("div", null, [e(u, {
				message: n,
				name: i.userName
			}, null, 8, ["message", "name"])]), r("div", _, [e(u, {
				message: n,
				name: i.userName
			}, null, 8, ["message", "name"])])], 64))]))), 128))])
		], 64));
	}
}), [["styles", ["*{box-sizing:border-box}:host{grid-template-rows:auto auto;grid-template-columns:1fr 1fr;gap:8px;display:grid}:host:after{content:\"\";background:#fff;border:1px solid #452d9d;border-radius:8px;grid-area:2/1}:host:before{content:\"\";background:#fff;border:1px solid #a16207;border-radius:8px;grid-area:2/2}.llm-compare-messages{flex-direction:column;grid-area:2/1/auto/span 2;gap:24px;max-height:460px;padding:6px;display:flex;position:relative;overflow-y:scroll}.llm-compare-messages__row{flex-direction:row;gap:32px;display:flex}.llm-compare-messages__row>div{flex-direction:column;width:50%;display:flex}.header{grid-area:1/1/auto/span 2;display:flex}.header div{justify-content:center;align-items:center;width:50%;padding:0 1rem;display:flex}.header p{text-align:center;background:#cec3f4;border:1px solid #452d9d;border-radius:8px;width:fit-content;margin:0;padding:8px 32px;font-family:Nunito,sans-serif;font-size:1.25rem;font-style:normal;font-weight:700;line-height:1.75rem}.header p.title-2{background:#fffec0;border-color:#a16207}.sr-only{clip-path:inset(50%);white-space:nowrap;border:0;width:1px;height:1px;padding:0;position:absolute;overflow:hidden}"]]]);
//#endregion
//#region src/webcomponents/pix-llm/llm-compare-messages.ce.js
window.customElements.define("llm-compare-messages", i(v));
//#endregion
